module.exports = __webpack_public_path__ + "img/clock-eight.44d3ec79.svg";